<template>
    <div class="m15 page_logo" ref="body" style="page-break-before: always;" id="investimento">
        <div class="site"></div>
        <hr />
        <h4 class="simulator-title loaded">Resumo de Necessidade de Investimentos</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao" />


        <div class="row">
            <div class="col l3"></div>
            <div class="col l6 s12">
                <table class="table striped print-table">
                    <thead >
                        <tr class="print-table-text-center">
                            <th scope="col">OBJETIVOS</th>
                            <th scope="col">APORTE INICIAL</th>
                            <th scope="col">INVESTIMENTO MENSAL</th>
                        </tr>
                    </thead>
                    <tbody class='print-table-text-center'>
                        <tr v-for="projeto in cliente.projetos" :key="`projeto-${projeto.projeto_id}`">
                            <td data-label="OBJETIVOS">{{ projeto.nome }} - {{ projeto.tempo_necessario }} ano(s)*</td>
                            <td data-label="APORTE INICIAL">{{ projeto.valor_reserva | dinheiro }}</td>
                            <td data-label="INVESTIMENTO MENSAL">{{ projeto.necessidade_investimento | dinheiro }}</td>
                        </tr>
                        <tr v-if="cliente.independencia_financeira">
                            <td data-label="OBJETIVOS">Aposentadoria {{ cliente.independencia_financeira.idade_aposentadoria }} ano(s)</td>
                            <td data-label="APORTE INICIAL">{{ cliente.independencia_financeira.aporte_inicial | dinheiro }}</td>
                            <td data-label="INVESTIMENTO MENSAL">{{ cliente.independencia_financeira.necessidade_investimento | dinheiro }}</td>
                        </tr>
                        <tr class="print-text-primary text-default">
                            <td class="print-bold" data-label="OBJETIVOS">Investimento Total</td>
                            <td class="print-bold" data-label="APORTE INICIAL">{{  total_aporte | dinheiro }}</td>
                            <td class="print-bold" data-label="INVESTIMENTO MENSAL">{{ total_investimento_mensal | dinheiro }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col l3"></div>
        </div>
        <div class="row">
            <div class="col l12 s12">
                <div class="texto">
                    * Lembrando que você pode optar pela aquisição de uma cota de consórcio, compra
                    programada do seu sonho, do seu projeto, o que lhe permite a antecipação do
                    mesmo via oferta de lance ou sorteio.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Saudacao from './Saudacao'
export default {
    name: 'ResumoInvestimentos',
    props: {
        cliente: {
            type: Object,
            default: null
        },
        empresa_selecionada: {
            type: Object,
            default: null
        }
    },

    components: {
        Saudacao
    },


    computed: {

        total_investimento_mensal() {
            let total = 0;

            this.cliente.projetos.forEach(projeto => {
                total += this.toNumber(projeto.necessidade_investimento)
            })

            if (this.cliente.independencia_financeira) {
                total += this.toNumber(this.cliente.independencia_financeira.necessidade_investimento)
            }

            return total;
        },

        total_aporte() {
            let total = 0;

            this.cliente.projetos.forEach(projeto => {
                total += this.toNumber(projeto.valor_reserva)
            })

            if (this.cliente.independencia_financeira) {
                total += this.toNumber(this.cliente.independencia_financeira.aporte_inicial)
            }

            return total;
        },
    },

    data() {
        return {
        }
    },
    methods: {
        async plot() {
            return this.$refs.body.outerHTML;
        },

        toNumber(num) {
            const n = parseFloat(num)
            return isNaN(n) ? 0 : n;
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../relatorios/Simulador.scss";

    .graph {
        text-align: center;
    }

    .total {
        font-size: 12px;
    }

    .block {
        width: 300px;
        margin-left: 120px;
        display: contents;
    }

    .texto {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .m5 {
        margin-top: 15px;
    }

    th {
        text-align: center;
    }

    td {
        text-align: center;
    }

    @media (min-width: 320px) and (max-width: 480px) {
        .block {
            width: 300px;
            margin-left: 25px;
            display: block;
        }
    }

    @media screen and (max-width: 600px) {
        table {
            border: 0;
        }

        table caption {
            font-size: 1.3em;
        }

        table thead {
            border: none;
            clip: rect(0 0 0 0);
            height: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            position: absolute;
            width: 1px;
        }

        table tr {
            border-bottom: 3px solid #ddd;
            display: block;
            margin-bottom: .625em;
        }

        table td {
            border-bottom: 1px solid #ddd;
            display: block;
            font-size: .8em;
            text-align: right;
        }

        table td::before {
            /*
      * aria-label has no advantage, it won't be read inside a table
      content: attr(aria-label);
      */
            content: attr(data-label);
            float: left;
            font-weight: bold;
            text-transform: uppercase;
            color: var(--color-primary);
        }

        table td:last-child {
            border-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/ResumoInvestimentos.vue